/**
 * @fileoverview GET handler for the "/app_settings/:app_group_id/message_prioritization/categories_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdMessagePrioritizationCategoriesData } from "./constants";
import type {
  AppSettingsAppGroupIdMessagePrioritizationCategoriesDataParams,
  GetMessagePrioritizationCategoriesResult,
  GetMessagePrioritizationCategoriesResultItem,
} from "./types";
import { isGetMessagePrioritizationCategoriesResult } from "./validators";

export const getMessagePrioritizationCategoriesData = reactQueryTableFetcherAdapter<
  typeof appSettingsAppGroupIdMessagePrioritizationCategoriesData,
  AppSettingsAppGroupIdMessagePrioritizationCategoriesDataParams,
  GetMessagePrioritizationCategoriesResultItem,
  GetMessagePrioritizationCategoriesResult
>(
  appSettingsAppGroupIdMessagePrioritizationCategoriesData,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: AppSettingsAppGroupIdMessagePrioritizationCategoriesDataParams
  ): Promise<GetMessagePrioritizationCategoriesResult> => {
    return fetch(
      `/app_settings/${appGroupId}/message_prioritization/categories_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isGetMessagePrioritizationCategoriesResult
);
